import FullScreenModalBody from "ds/components/FullScreenModal/Body";
import FullScreenModalBodyHeader from "ds/components/FullScreenModal/BodyHeader";

import { SCHEDULE_SCAN_WIZARD_STEP_HEADERS } from "../constants";
import { NewScanScheduleStep } from "../types";

const NewScanScheduleStepResourceFilters = () => {
  return (
    <FullScreenModalBody>
      <FullScreenModalBodyHeader
        {...SCHEDULE_SCAN_WIZARD_STEP_HEADERS[NewScanScheduleStep.ResourceFilters]}
      />
    </FullScreenModalBody>
  );
};

export default NewScanScheduleStepResourceFilters;
